import { AsyncPipe, NgIf } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	OnInit,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { concat, Observable, of, takeUntil, tap } from 'rxjs';
type Mode = 'outline' | 'flat';
@Component({
	selector: 'app-dc-core-badge',
	styleUrls: ['./app-dc-core-badge.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	inputs: ['icon', 'label', 'mode', 'filled', 'type'],
	template: `
		<div *ngIf="vo$ | async; let vo" class="dc-core-badge">
			<mat-icon
				*ngIf="vo.icon"
				[svgIcon]="vo.icon"
				class="dc-core-badge-icon"></mat-icon>
			<ng-content></ng-content>

			<span *ngIf="vo.label !== ''" class="dc-core-badge-label">
				{{ vo.label }}
			</span>
		</div>
	`,
	imports: [AsyncPipe, NgIf, MatIconModule],
})
export class AppDcCoreBadgeComponent extends DcBaseComponent implements OnInit {
	@HostBinding('class.outlined') private outlined = false;
	@HostBinding('class.filled') private isFilled = false;
	@HostBinding('class.warn') private warn = false;
	public vo$!: Observable<{
		icon: string | null;
		label: string;
	}>;

	public override ngOnInit(): void {
		super.ngOnInit();

		this.toObservable<Mode>('mode')
			.pipe(
				takeUntil(this.onDestroy$),
				tap((mode) => (this.outlined = mode === 'outline'))
			)
			.subscribe();

		this.toObservable<boolean>('filled')
			.pipe(
				takeUntil(this.onDestroy$),
				tap((filled) => (this.isFilled = filled))
			)
			.subscribe();

		this.toObservable<string>('type')
			.pipe(
				takeUntil(this.onDestroy$),
				tap((type) => (this.warn = type === 'warning'))
			)
			.subscribe();

		this.vo$ = combineAll({
			icon: concat(of(null), this.toObservable<string>('icon')),
			label: concat(of(''), this.toObservable<string>('label')),
		});
	}
}
